import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { serviceMutations } from "@/queries/services/mutations";
import { useServiceQueries } from "@/queries/services/queryOptions";

import { ServicePartnerDetails } from "../components/ServicePartnerDetails";

export function ServicePartnerDetailsPage(): React.ReactNode {
  const { id: serviceId } = useParams<{ id: string }>();
  const serviceIdForQuery = serviceId ?? "";

  const servicePartnerQueries = useServiceQueries();
  const {
    data: serviceDetails,
    isPending: isPendingServiceDetails,
    error: serviceDetailsError,
  } = useQuery({
    ...servicePartnerQueries.details({ serviceId: serviceIdForQuery }),
    enabled: !!serviceId,
  });
  const deleteServiceMutation = serviceMutations.useDeleteService();

  const error = !serviceId || serviceDetailsError;
  if (error) {
    return <ErrorPage error={error} />;
  }

  if (isPendingServiceDetails) {
    return <FullSizeLoader withPadding />;
  }

  return <ServicePartnerDetails serviceDetails={serviceDetails} onDelete={deleteServiceMutation.mutateAsync} />;
}
